import React from 'react'
import Pt from 'prop-types'
import { connect } from 'react-redux'
import Ipt from 'react-immutable-proptypes'
import cx from 'classnames'

import 'font-awesome/css/font-awesome.css'
import Dimensions from 'internal-components/src/containers/Dimensions'

import './bootstrap.less'
import './CoreLayout.css'

import Footer from '../components/Layout/Footer'
import Header from '../components/Layout/Header'

export function CoreLayout({ children, loading, user }) {
  return (
    <Dimensions>
      <section
        id="application"
        style={{ height: '100%' }}
        className={cx({ loading })}
      >
        <Header user={user} />

        <div id="wrapper">{children}</div>

        <Footer />
      </section>
    </Dimensions>
  )
}

CoreLayout.propTypes = {
  children: Pt.element,
  loading: Pt.bool.isRequired,
  user: Ipt.record,
}

const mapStateToProps = ({ authentication, meta }) => ({
  loading: meta.get('loading', false),
  user: authentication.get('user'),
})

export default connect(mapStateToProps)(CoreLayout)



// WEBPACK FOOTER //
// ./src/layouts/CoreLayout.jsx